// Block 1 (owner 2026-10-08): the over-invoiced ALERT, on the ORDER HEADER (below the refund block, above the tabs, whichever tab is open).
// Shown only when the server says so (status snapshot states.needs_correction: issued - credit notes - recognised > 0.50, never on a "Not to be invoiced" order).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Emo } from '../../shell/EmojiIcons';
import { formatMoneyExact } from '../../utils/format';

// the existing customer credit-note drawer, locked to the order and pre-filled with the over-invoiced amount (the server preview enforces the cap)
export const openCreditNote = (op, partnerId, partnerName, amount, sourceRef = '') => window.dispatchEvent(new CustomEvent('open-create-drawer', { detail: { id: 'credit-note-customer', params: { operationId: op, partner_id: partnerId || '', partner_name: partnerName || '', amount, sourceRef } } }));   // sourceRef: pre-ticks that event in the form

export default function OverInvoicedBanner({ snapshot, operationId, partnerId, customerName }) {
  const { t } = useTranslation('invoicing');
  if (!snapshot || !snapshot.states?.needs_correction) return null;
  const amount = snapshot.money.over_invoiced;
  return (
    <div className="ov-banner" role="alert" data-testid="order-over-banner">
      <Emo name="warn" /><div className="ov-txt">{t('overBanner', { amount: formatMoneyExact(amount) })}</div>
      <button type="button" className="btn primary" data-testid="inv-issue-credit-note" onClick={() => openCreditNote(operationId, partnerId, customerName, amount)}>{t('issueCreditNote')}</button>
    </div>
  );
}
